import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { delay, filter, take, takeUntil } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';

import { FuseConfigService } from 'src/@fuse/services/config.service';
import { FuseNavigationService } from 'src/@fuse/components/navigation/navigation.service';
import { FusePerfectScrollbarDirective } from 'src/@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { FuseSidebarService } from 'src/@fuse/components/sidebar/sidebar.service';

import { select, Store } from '@ngrx/store';
import {
  AppState,
  currentUser,
  currentEstablecimientoSelected,
  UserEstablecimientoSelectedRequested,
  isEstablecimientoSelected,
  selectProductosPedidosPendientes,
} from 'src/app/store';

import { MatDialog } from '@angular/material/dialog';
import { SeleccionEstablecimientoComponent } from 'src/app/main/pages/generals/seleccionar-establecimiento/seleccionar-establecimiento.component';
import { SubmenuComponent } from 'src/app/main/pages/generals/submenu/submenu.component';

@Component({
  selector: 'navbar-vertical-style-1',
  templateUrl: './style-1.component.html',
  styleUrls: ['./style-1.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NavbarVerticalStyle1Component implements OnInit, OnDestroy {
  fuseConfig: any;
  navigation: any;
  account$: any;
  getAccount$: any;
  establecimientos$: any;
  establecimientoSelected$: any;

  productosPedidosPendientes?: any[] = [];
  isEstablecimientoSelected?: boolean;
  showMenu?: boolean;
  showServicios?: boolean;
  showBienes?: boolean;
  sessionsData: any;

  // Private
  private _fusePerfectScrollbar?: FusePerfectScrollbarDirective;
  private _unsubscribeAll: Subject<any>;

  constructor(
    private _fuseConfigService: FuseConfigService,
    private _fuseNavigationService: FuseNavigationService,
    private _fuseSidebarService: FuseSidebarService,
    private store: Store<AppState>,
    private _router: Router,
    private _sanitizer: DomSanitizer,
    public dialog: MatDialog,
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  // Directive
  @ViewChild(FusePerfectScrollbarDirective, { static: true })
  set directive(theDirective: FusePerfectScrollbarDirective) {
    if (!theDirective) {
      return;
    }

    this._fusePerfectScrollbar = theDirective;

    // Update the scrollbar on collapsable item toggle
    this._fuseNavigationService.onItemCollapseToggled
      .pipe(delay(500), takeUntil(this._unsubscribeAll))
      .subscribe(() => {
        this._fusePerfectScrollbar?.update();
      });

    // Scroll to the active item position
    this._router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        take(1),
      )
      .subscribe(() => {
        setTimeout(() => {
          this._fusePerfectScrollbar?.scrollToElement(
            'navbar .nav-link.active',
            -120,
          );
        });
      });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this._router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this._unsubscribeAll),
      )
      .subscribe(() => {
        if (this._fuseSidebarService.getSidebar('navbar')) {
          this._fuseSidebarService.getSidebar('navbar')?.close();
        }
      });

    // Subscribe to the config changes
    this._fuseConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config: any) => {
        this.fuseConfig = config;
      });

    // Get current navigation
    this._fuseNavigationService.onNavigationChanged
      .pipe(
        filter(value => value !== null),
        takeUntil(this._unsubscribeAll),
      )
      .subscribe(() => {
        this.navigation = this._fuseNavigationService.getCurrentNavigation();
      });

    try {
      this.sessionsData = localStorage.getItem('sessions');
      let dataParsed = JSON.parse(this.sessionsData);

      if (dataParsed && dataParsed.length > 0) {
        const usernameToFind = sessionStorage.getItem('username');
        const foundUser = dataParsed.find(
          (user: any) => user.username === usernameToFind,
        );
        this.account$ = foundUser || { username: 'undefined' };
      } else {
        this.account$ = { username: 'undefined' };
      }
    } catch (error) {
      this.account$ = { username: 'undefined' };
    }

    /*
                this.account$ = this.store.pipe(
                    takeUntil(this._unsubscribeAll),
                    select(currentUser)
                );
        
                this.store.pipe(
                    takeUntil(this._unsubscribeAll),
                    select(selectProductosPedidosPendientes),
                    filter(user => user)
                ).subscribe(pendientes => {
                    this.productosPedidosPendientes = pendientes;
                });
        */
    this.getAccount$ = this.store
      .pipe(
        takeUntil(this._unsubscribeAll),
        select(currentUser),
        filter(user => user),
      )
      .subscribe(user => {
        this.showMenu = user.isArchivosLoaded;
      });

    this.establecimientoSelected$ = this.store.pipe(
      takeUntil(this._unsubscribeAll),
      select(currentEstablecimientoSelected),
    );

    this.store
      .pipe(takeUntil(this._unsubscribeAll), select(isEstablecimientoSelected))
      .subscribe(isSelected => {
        this.isEstablecimientoSelected = isSelected;
      });

    this.store
      .pipe(
        takeUntil(this._unsubscribeAll),
        select(currentEstablecimientoSelected),
        filter(establecimiento => establecimiento),
      )
      .subscribe(establecimiento => {
        switch (establecimiento.sector) {
          case 'COMERCIAL':
          case 'INDUSTRIAL':
            this.showBienes = true;
            this.showServicios = false;
            break;
          case 'SERVICIO':
            this.showBienes = false;
            this.showServicios = true;
            break;
          case 'COMERCIAL_SERVICIO':
          case 'INDUSTRIAL_SERVICIO':
            this.showBienes = true;
            this.showServicios = true;
            break;
          default:
            this.showBienes = false;
            this.showServicios = false;
        }
      });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle sidebar opened status
   */
  toggleSidebarOpened(): void {
    this._fuseSidebarService.getSidebar('navbar')?.toggleOpen();
  }

  /**
   * Toggle sidebar folded status
   */
  toggleSidebarFolded(): void {
    this._fuseSidebarService.getSidebar('navbar')?.toggleFold();
  }

  sanitizeImagen(establecimiento: any): any {
    let imagen = establecimiento.establecimientosImagen;
    if (establecimiento.padre) {
      imagen = establecimiento.padre.establecimientosImagen;
    }

    if (imagen) {
      return this._sanitizer.bypassSecurityTrustResourceUrl(
        'data:' + imagen.imagenContentType + ';base64, ' + imagen.imagen,
      );
    } else {
      return './assets/images/default-avatar.png';
    }
  }

  imagenDefault(): any {
    return './assets/images/default-avatar.png';
  }

  openSeleccionarEstablecimiento(): void {
    const dialogRef = this.dialog.open(SeleccionEstablecimientoComponent);

    dialogRef.afterClosed().subscribe(response => {
      if (response && response.res) {
        const id = response.data.id;
        this.store.dispatch(
          new UserEstablecimientoSelectedRequested({ id: id }),
        );
      }
    });
  }

  onMenu(): void {
    this._router.navigate(['/perfil-facturacion']);
  }

  onSubmenu(): void {
    const dialogRef = this.dialog.open(SubmenuComponent);

    dialogRef.afterClosed().subscribe(response => {});
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(void 0);
    this._unsubscribeAll.complete();
  }
}
